export default __webpack_public_path__ + "static/media/multiple-search-type.cfbfb211.svg";